// actions
export default {
  // 更新小区列表
  updateCommunities(context, val) {
    context.commit('updateCommunities', val)
  },
  // 更新商圈
  updateBusinesses(context, val) {
    context.commit('updateBusinesses', val)
  },
  // 更新各区县
  updateCounties(context, val) {
    context.commit('updateCounties', val)
  },
  // reaload 小区
  reloadCommunities(context) {
    context.commit('reloadCommunities')
  },
  // reload 商圈
  reloadBusiness(context) {
    context.commit('reloadBusiness')
  },
  // reload 县区
  reloadCounties(context) {
    context.commit('reloadCommunities')
  },
  // 更新微信ready状态
  updateWxReady(context, val) {
    context.commit('updateWxReady', val)
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js